import '../css/add_new_aid_record.css';
import React, { useState, useContext } from "react";
import { postStuff } from '../helpers/auth';
import { MyDateTimePicker, ButtonWIcon } from './Inputs';
import { newAidContext } from "./ClientPage";
import { AlertsContext } from './Layout'
import { authenticatedContext } from '../App'
import { toIsoStringWTimeZoneWOSeconds } from '../helpers/date_conversion';
import { refreshClientProject } from './ClientProjectOverview';


export function AddNewAidRecordWindow({ projectId, clientId }) {

    const [aidTS, setAidTS] = useState(toIsoStringWTimeZoneWOSeconds(new Date()))
    const [newAidOpen, setNewAidOpen] = useContext(newAidContext);

    const addAlertBanner = useContext(AlertsContext);
    const { authenticated, setAuthenticated } = useContext(authenticatedContext);
    const [refresh, setRefresh] = useContext(refreshClientProject);

    function handleSave() {

        const body = {
            ts: aidTS,
            project_id: projectId,
            client_id: clientId
        }

        postStuff("aid_record/create_new/", body).then((res) => {
            if (res.status === 200) {
                addAlertBanner("Podpora zapsána", "success")
                closeItself()
            } else if (res.status == 400) {
                if (res.data.error)
                    addAlertBanner(res.data.error, "danger")
                else
                    addAlertBanner("Něco se pokazilo", "danger");
            }
            else if (res.status === 401) {
                setAuthenticated(false);
            } else {
                console.log("error", res)
                addAlertBanner("Něco se pokazilo", "danger");
            }
        });
    }

    function closeItself() {
        setNewAidOpen(false);
        setRefresh(!refresh);
    }

    return (
        <div className='blur-container'>
            <div className="add-new-aid-record-window">
                <div className='new-aid-header'>
                    <h1>Nový záznam o podpoře</h1>
                    <ButtonWIcon iconSrc={"/img/svg/close_round_red.svg"} onClick={closeItself} style={{ backgroundColor: "white" }} />
                </div>
                <div className='aid-picker-div'>
                    <MyDateTimePicker value={aidTS} setValue={setAidTS} />
                </div>
                <div className='new-aid-controls'>
                    <ButtonWIcon
                        iconSrc={"/img/svg/save.svg"}
                        onClick={handleSave}
                        style={{ backgroundColor: "#68E965" }}
                        text={"Uložit"} />
                </div>
            </div>
        </div>
    )
}